<listview *ngIf="config" [config]="config" class="page-layout simple left-sidebar inner-sidebar inner-scroll">
</listview>
